import { Tab } from '@mui/material';
import { SyntheticEvent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Sign } from '../../model/sign';
import { HeadCell } from '../../model/table';
import CardBox from '../ui/containers/CardBox';
import TabPanel from '../ui/tabs/TabPanel';
import TabsCommon from '../ui/tabs/TabsCommon';
import TableTestSignList from './TableTestSignList';

interface UploadedSeal {
	id: string;
	title: string;
	imageUrl: string;
	canDrag: boolean;
}

type Props = {
	id: number;
	value: number;
	onChange: (_: SyntheticEvent, v: number) => void;
	onDrop: (item: any, dropResult: any) => void;
	uploadedImage?: UploadedSeal;
	signs: Sign[];
};

export default function TabsTestSign({ id, value, onChange, onDrop, uploadedImage, signs }: Props) {
	const { t } = useTranslation();

	const label = (key: string) => {
		return t(key).replaceAll('{{인장}}', '인장').replaceAll('{{날인}}', '날인');
	};

	const uploadedList = useMemo(() => {
		return uploadedImage
			? [
					{
						...uploadedImage,
						status: '',
						user: '',
						date: '',
						type: 'normal',
					},
			  ]
			: [];
	}, [uploadedImage]);

	const headCellsUploaded: HeadCell<UploadedSeal>[] = [
		{
			id: 'imageUrl',
			width: 'w-[130px]',
			align: 'left',
			disablePadding: false,
			sort: false,
			label: t('label_image'),
		},
		{
			id: 'title',
			align: 'left',
			disablePadding: false,
			sort: true,
			label: 'width',
		},
	];

	return (
		<CardBox>
			<TabsCommon classes={{ indicator: 'h-1 bg-blue-300' }} value={value} onChange={onChange}>
				<Tab
					classes={{ root: 'min-w-0 min-h-0 px-10 py-5 text-gray-950', selected: 'font-bold' }}
					id='sign-tab-1'
					label={label('label_list_seal')}
				/>
			</TabsCommon>

			<TabPanel value={value} index={0}>
				<TableTestSignList
					sealStampId={id}
					signs={signs}
					list={uploadedList}
					headCells={headCellsUploaded as any}
					onDrop={onDrop}
				/>
			</TabPanel>
		</CardBox>
	);
}
